import { render } from "./admin-menu.vue?vue&type=template&id=47bf5092&scoped=true"
import script from "./admin-menu.vue?vue&type=script&lang=js"
export * from "./admin-menu.vue?vue&type=script&lang=js"

import "./admin-menu.vue?vue&type=style&index=0&id=47bf5092&lang=scss&scoped=true"

import exportComponent from "/home/gebruiker/www/profs-computers/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47bf5092"]])

export default __exports__